import AlertConfigOption from "./AlertConfigOption";
import { FaCircleCheck, FaTelegram } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { PiWarningFill } from "react-icons/pi";
import styles from "../../../styles/Components/alert-system/alert-config/TelegramNotificationBox.module.css";
import { FaTelegramPlane } from "react-icons/fa";
import { Button } from "antd";
import React from "react";

function TelegramNotificationBox() {
  const {
    profile: { profileData },
    alertSystem: { telegramBotToken },
  } = useSelector((state) => state);

  const telegramLink = telegramBotToken
    ? `https://t.me/cryptocrispy_bot?start=${telegramBotToken}`
    : "https://t.me/cryptocrispy_bot";

  const isTelegramConnected = profileData?.telegram_chat_id;

  return (
    <AlertConfigOption title="Telegram Notification" icon={<FaTelegram />}>
      <p>
        Status:{" "}
        <span
          style={{ color: `${isTelegramConnected ? "#44bd32" : "#E74C3C"}` }}
        >
          {isTelegramConnected ? "Connected" : "Not Connected"}
        </span>
      </p>

      {!isTelegramConnected ? (
        <div className={styles.telegramWarning}>
          <PiWarningFill size={16} />
          <span>You are not receiving alerts on Telegram</span>
        </div>
      ) : (
        <div className={styles.telegramConnected}>
          <FaCircleCheck />
          <span>You are receiving alerts on Telegram</span>
        </div>
      )}

      <Button className={styles.telegramBtn}>
        <a href={telegramLink} target={"_blank"} rel="noreferrer">
          <FaTelegramPlane />
          {!isTelegramConnected
            ? window.innerWidth > 600
              ? "Get Alerts in Telegram"
              : "Telegram Alerts"
            : "Check Telegram Alerts"}
        </a>
      </Button>
    </AlertConfigOption>
  );
}

export default TelegramNotificationBox;
